import { render, staticRenderFns } from "./MaintainerList.vue?vue&type=template&id=3628f619"
import script from "./MaintainerList.vue?vue&type=script&lang=js"
export * from "./MaintainerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports